module.exports = __webpack_public_path__ + "img/dogs-allowed.2.c41a63b.jpg";